document.addEventListener("teeinblue-event-after-cart-added", function () {
  if (!/\/cart/.test(window.location.href)) {
    // is not cart page
    var request = new XMLHttpRequest();
    request.open("POST", "/cart/update.js", true);
    request.setRequestHeader("Content-Type", "application/json");
    request.onload = function () {
      if (this.status >= 200 && this.status < 400) {
        var response = JSON.parse(this.response);
        T4SThemeSP.Cart.renderContents(response.sections);
      }
    };
    request.send(
      JSON.stringify({
        sections: "cart_data,mini_cart",
        sections_url: window.location.pathname,
      })
    );

    document.dispatchEvent(new CustomEvent("cart:refresh:opend"));
  }
});

let initialSizeValue = null;
let initialColorValue = null;

function saveInitialValues() {
  const selectedSize = document.querySelector(".tee-option--size .tee-radio input:checked");
  const selectedColor = document.querySelector(".tee-option--color .tee-radio input:checked");
  if (selectedSize) initialSizeValue = selectedSize.value;
  if (selectedColor) initialColorValue = selectedColor.value;
}

function reattachOptionClickEvents() {
  document.querySelectorAll(".tee-option--size .tee-radio-label, .tee-option--color .tee-radio-label").forEach(label => {
    label.addEventListener("click", function () {
      const input = label.previousElementSibling || label.nextElementSibling;
        
      if (input && input.tagName === "INPUT") {
        if (input.closest(".tee-option--size")) initialSizeValue = input.value;
        if (input.closest(".tee-option--color")) initialColorValue = input.value;
      }
    });
  });
}


function restoreSizeAndColor() {
    setTimeout(() => {
        if (initialSizeValue) {
            const sizeToClick = document.querySelector(`.tee-option--size .tee-radio input[value="${initialSizeValue}"]`);
            if (sizeToClick) {
                const sizeLabel = sizeToClick.closest('.tee-radio')?.querySelector('.tee-radio-label');
                if (sizeLabel) sizeLabel.click();
            }
        }

        setTimeout(() => {
            if (initialColorValue) {
                const colorToClick = document.querySelector(`.tee-option--color .tee-radio input[value="${initialColorValue}"]`);
                if (colorToClick) {
                    const colorLabel = colorToClick.closest('.tee-radio')?.querySelector('.tee-radio-label');
                    if (colorLabel) colorLabel.click();
                }
            }
        }, 50);
        reattachOptionClickEvents();
    }, 50);
}

document.addEventListener("teeinblue-event-component-injected", () => {
  document.querySelectorAll(".tee-available-products .tee-clipart-label, .tee-available-products .tee-radio-label").forEach((label) => {
      label.addEventListener("click", function () {
        setTimeout(restoreSizeAndColor, 50);
      });
    saveInitialValues();
    reattachOptionClickEvents();
  })
})
